import { createContext, useContext } from 'react';
import { RepositoryRegistry } from '@mews-distributor/data-access';

export const RepositoryContext = createContext<RepositoryRegistry | undefined>(undefined);

export const useRepositories = (): RepositoryRegistry => {
    const repositories = useContext(RepositoryContext);

    if (repositories == null) {
        throw new Error('Repositories are not set in app context');
    }

    return repositories;
};
